export const API_COLLECTION_INIT = 'API_COLLECTION_INIT'
export const API_COLLECTION_SAVE = 'API_COLLECTION_SAVE'
export const API_COLLECTION_UPDATE = 'API_COLLECTION_UPDATE'
